import React from 'react'
import LoginLayoutContainer from './LoginLayoutContainer'

const Layout = (props) => (
  <LoginLayoutContainer {...props} />
)

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/index.js